// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__de69i","footer":"ModalUpdate_footer__38rNK"};